import { Moment } from 'moment'
import { useState } from 'react'

import {
  AttendanceEmployeeByDayHeader,
  AttendanceEmployeeByDayTable,
  AttendanceEmployeeByRangeDayTable,
  AttendanceTotalEmployeeByRangeDayTable,
  FilterAttendanceEmployeeByDay,
} from '@/components/pages/AttendanceEmployee/EmployeeByDay'
import { useEmployees } from '@/pages/Employees/Employees.hooks'
import { DateType } from '@/types'

import { useAttendanceEmployeeByDay } from './AttendanceEmployeeByDay.hooks'

export type FilterDateEmployee = {
  type: DateType
  fromDate: Moment | null
  toDate: Moment | null
  totalFromDate: Moment | null
  totalToDate: Moment | null
}

export const defaultFilterDate: FilterDateEmployee = {
  type: DateType.NO_SELECT,
  fromDate: null,
  toDate: null,
  totalFromDate: null,
  totalToDate: null,
}

const AttendanceEmployeeByDay = () => {
  const [dateFilter, setDateFilter] = useState<Moment | null>()
  const [employeeFilter, setEmployeeFilter] = useState(false)
  const [dateRangeFilter, setDateRangeFilter] = useState<FilterDateEmployee>(defaultFilterDate)
  const { getAllEmployees, allEmployeesResponse, getValueSearchEmployee, valueSearchEmployee } = useEmployees()

  const handleFilterEmployee = () => {
    setEmployeeFilter((pre) => !pre)
  }

  const {
    getAttendanceEmployeeByDay,
    responseAttendanceEmployee,
    responseAttendanceEmployeeLoading,
    exportExcelAttendanceEmployeeByDay,
    exportEmployeeByRangeDayLoading,
    exportTotalEmployeeLoading,
    exportEmployeeLoading,
    exportExcelEmployeeByRangeDate,
    exportExcelTotalEmployeeByRangeDay,
    getEmployeeByRangeDay,
    getTotalEmployeeByRangeDay,
    responseAttendanceEmployeeByRangeDay,
    responseAttendanceEmployeeByRangeDayLoading,
    responseAttendanceTotalEmployee,
    responseAttendanceTotalEmployeeLoading,
  } = useAttendanceEmployeeByDay()

  return (
    <>
      <AttendanceEmployeeByDayHeader />
      <FilterAttendanceEmployeeByDay
        setDateFilter={setDateFilter}
        getAttendanceEmployeeByDay={getAttendanceEmployeeByDay}
        exportExcelAttendanceEmployeeByDay={exportExcelAttendanceEmployeeByDay}
        getEmployeeByRangeDay={getEmployeeByRangeDay}
        exportExcelEmployeeByRangeDate={exportExcelEmployeeByRangeDate}
        getTotalEmployeeByRangeDay={getTotalEmployeeByRangeDay}
        exportExcelTotalEmployeeByRangeDay={exportExcelTotalEmployeeByRangeDay}
        exportEmployeeLoading={exportEmployeeLoading}
        exportEmployeeByRangeDayLoading={exportEmployeeByRangeDayLoading}
        exportTotalEmployeeLoading={exportTotalEmployeeLoading}
        dateFilter={dateFilter}
        getAllEmployees={getAllEmployees}
        allEmployeesResponse={allEmployeesResponse}
        setDateRangeFilter={setDateRangeFilter}
        dateRangeFilter={dateRangeFilter}
        getValueSearchEmployee={getValueSearchEmployee}
        valueSearchEmployee={valueSearchEmployee}
        employeeFilter={employeeFilter}
        setEmployeeFilter={setEmployeeFilter}
      />
      {dateFilter && responseAttendanceEmployee?.employees.length !== 0 && (
        <AttendanceEmployeeByDayTable
          responseAttendanceEmployee={responseAttendanceEmployee}
          responseAttendanceEmployeeLoading={responseAttendanceEmployeeLoading}
          dateFilter={dateFilter}
          employeeFilter={employeeFilter}
          handleFilterEmployee={handleFilterEmployee}
        />
      )}

      {responseAttendanceEmployeeByRangeDay && dateRangeFilter.fromDate && dateRangeFilter.toDate && (
        <AttendanceEmployeeByRangeDayTable
          responseAttendanceEmployeeByRangeDay={responseAttendanceEmployeeByRangeDay}
          responseAttendanceEmployeeByRangeDayLoading={responseAttendanceEmployeeByRangeDayLoading}
          employeeFilter={employeeFilter}
          handleFilterEmployee={handleFilterEmployee}
        />
      )}

      {responseAttendanceTotalEmployee && dateRangeFilter.totalFromDate && dateRangeFilter.totalToDate && (
        <AttendanceTotalEmployeeByRangeDayTable
          responseAttendanceTotalEmployee={responseAttendanceTotalEmployee}
          responseAttendanceTotalEmployeeLoading={responseAttendanceTotalEmployeeLoading}
          employeeFilter={employeeFilter}
          handleFilterEmployee={handleFilterEmployee}
        />
      )}
    </>
  )
}

AttendanceEmployeeByDay.displayName = 'AttendanceEmployeeByDay'
export default AttendanceEmployeeByDay
